var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.8281 21.5C42.8281 33.0031 33.5031 42.3281 22 42.3281C10.4969 42.3281 1.17188 33.0031 1.17188 21.5C1.17188 9.99691 10.4969 0.671875 22 0.671875C33.5031 0.671875 42.8281 9.99691 42.8281 21.5ZM19.5908 32.5283L35.0439 17.0752C35.5687 16.5505 35.5687 15.6996 35.0439 15.1749L33.1436 13.2746C32.6189 12.7498 31.7681 12.7498 31.2432 13.2746L18.6406 25.8771L12.7568 19.9932C12.232 19.4685 11.3812 19.4685 10.8564 19.9932L8.95605 21.8936C8.43132 22.4183 8.43132 23.2691 8.95605 23.7939L17.6904 32.5282C18.2152 33.0531 19.066 33.0531 19.5908 32.5283Z",
    fill: "#18B680"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.26ae15d9d560c459b50954e9a50a45af.svg";
export { ForwardRef as ReactComponent };